export const ENDPOINTS = {
  CONTENTS: {
    STORIES: "/contents/stories",
    FAQ: "/contents/faq",
    SITE_METADATA: "/contents/site-metadata",
  },
  ACCOMMODATIONS: {
    SEARCH: "/search/city",
    /** Aggregated PLP filter options (amenities, types, origins, sort, rating, price) */
    SEARCH_FILTERS: "/search/filters",
    /** City typeahead for the destination picker */
    CITY_AUTOCOMPLETE: "/search/cities/autocomplete",
    /** Full-text accommodation search */
    TEXT_SEARCH: "/search/accommodations/text",
    DISCOVERY: (section: string) => `/discovery/${section}`,
    /** Popular cities for the landing page */
    POPULAR_DESTINATIONS: "/discovery/popular",
    DETAIL: (stateCity: string, slug: string) =>
      `/accommodations/${stateCity}/${slug}`,
    /**
     * Resolves the booking-origin URL for a single offer.
     *
     * The id is the *offer* identity, not the canonical accommodation: one PDP
     * lists several origins, and each has to land on its own site. Today that
     * is the price row's `hashId` (constant per origin across nights); the
     * legacy payload carried a per-origin `accommodationId` instead, so the
     * booking interstitial falls back to the accommodation id.
     */
    REDIRECT: (offerId: string) => `/accommodations/redirect/${offerId}`,
    /**
     * Multi-origin stay pricing for the PDP price card.
     *
     * POST body: `{ checkIn, checkOut, capacity }`. Resolves which origins can
     * serve the stay, refreshing stale prices in-band — so the client no longer
     * has to chase `prices/refresh` and stitch nightly rows together itself.
     */
    PRICES_PDP: (accommodationId: string) =>
      `/accommodations/${accommodationId}/prices/pdp`,
    /**
     * Available-night allowlist for the PDP datepicker.
     *
     * `from` / `to` are inclusive `YYYY-MM-DD`; the range may not exceed
     * 62 days. Refetch when guest `capacity` changes.
     */
    PRICES_CALENDAR: (
      accommodationId: string,
      from: string,
      to: string,
      capacity: number,
    ) =>
      `/accommodations/${accommodationId}/prices/calendar?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&capacity=${capacity}`,
    AMENITIES: (accommodationId: string) =>
      `/accommodations/tags?accommodationId=${accommodationId}`,
    RATINGS: (accommodationId: string) =>
      `/feedbacks/ratings/${accommodationId}`,
    REVIEWS: (accommodationId: string) =>
      `/feedbacks/ai-reviews/${accommodationId}`,
    IMAGES: (accommodationId: string) =>
      `/images/accommodations/${accommodationId}`,
  },
  HEALTH: {
    READY: "/health/ready",
    MONITOR: "/health/monitor",
  },
  REFERENCES: {
    CITIES: "/references/cities",
    PROVINCES: "/references/provinces",
    ORIGINS: "/references/origins",
    ACCOMMODATION_TYPES: "/references/types",
    TAGS: "/references/tags",
    /** Only tags usable in PLP filters */
    FILTER_TAGS: "/references/tags?inFilter=true",
  },
} as const;
